import { jsx as _jsx } from "react/jsx-runtime";
import ContentBox from "./ContentBox";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import IconButton from "@material-ui/core/IconButton";
DetailsBox.displayName = "DetailsBox";
function DetailsBox(props) {
    const { onClick, ...rest } = props;
    return (_jsx(ContentBox, { ...rest, headerAction: _jsx(IconButton, { onClick: onClick, children: _jsx(ChevronLeftIcon, {}) }) }));
}
export default DetailsBox;
//# sourceMappingURL=DetailsBox.js.map